// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand-widget {
  position: relative;
  display: flex;
  flex-direction: column;
}

.image-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.image-container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.image-container .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.image-container .loading-container ion-spinner {
  --color: #ed143d;
}
.image-container .loading-container p {
  margin: 0;
  color: #666;
  font-size: 14px;
}
.image-container .placeholder-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  padding-bottom: 0;
  text-align: center;
}
.image-container .placeholder-container .placeholder-icon {
  font-size: 48px;
  color: #ccc;
}
.image-container .placeholder-container .placeholder-message {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/brand-widget/brand-widget.component.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAFJ;AAII;EACE,gBAAA;AAFN;AAKI;EACE,SAAA;EACA,WAAA;EACA,eAAA;AAHN;AAOE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AALJ;AAOI;EACE,eAAA;EACA,WAAA;AALN;AAQI;EACE,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AANN","sourcesContent":["  \n\n.brand-widget {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.image-container {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  \n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n  \n  .loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    \n    ion-spinner {\n      --color: #ed143d;\n    }\n    \n    p {\n      margin: 0;\n      color: #666;\n      font-size: 14px;\n    }\n  }\n  \n  .placeholder-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 20px;\n    padding-bottom: 0;\n    text-align: center;\n    \n    .placeholder-icon {\n      font-size: 48px;\n      color: #ccc;\n    }\n    \n    .placeholder-message {\n      margin: 0;\n      color: #666;\n      font-size: 14px;\n      line-height: 1.4;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
